<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>

      <v-card-text>
        <v-radio-group v-model="value" :color="color">
          <v-radio
            v-for="item in items"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :color="color"
          />
        </v-radio-group>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Cancelar</v-btn>
        <v-btn :color="color" dark @click="submit"> Confirmar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "RadioFieldDialog",

  props: {
    title: {
      type: String,
      required: true,
    },
    fieldLabel: String,
    items: {
      type: Array,
      required: true,
    },
    color: {
      type: String,
      default: "red",
    },
  },

  data() {
    return {
      dialog: false,
      value: null,
    };
  },

  methods: {
    open(currentValue) {
      this.value = currentValue;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    submit() {
      this.$emit("submit", this.value);
      this.close();
    },
  },
};
</script>
